




















































import Vue from 'vue'
import moment from 'moment'

import cTrend from './trend.vue'
import { Parameter, InfluxResult } from '@/api/cems'

import { EChartsOption } from 'echarts'

function generateDefaultOption(): EChartsOption {
  return {
    animation: false,
    grid: {
      top: 20,
      left: '0px',
      right: '50px',
      bottom: '60px',
      containLabel: true,
    },
    backgroundColor: 'transparent',
    title: {
      show: false,
      textAlign: 'center',
      left: 'center',
      top: 10,
      textStyle: {
        align: 'center',
        fontWeight: 'normal',
        fontSize: 12,
        lineHeight: 10,
      },
      subtextStyle: {
        fontSize: 11,
        color: '#000',
        lineHeight: 10,
        align: 'left',
      },
    },

    legend: { show: false },

    tooltip: {
      trigger: 'axis',
    },
    xAxis: [
      {
        type: 'time',
        boundaryGap: false,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#57617B',
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        axisTick: {
          show: true,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#57617B',
          },
        },
        axisLabel: {
          margin: 10,
        },
        splitLine: {},
      },
    ],
    dataZoom: [
      {
        show: true,
        xAxisIndex: 0,
        realtime: true,
        start: 0,
        end: 100,
      },
      {
        show: true,
        yAxisIndex: 0,
        realtime: true,
        start: 0,
        end: 100,
      },
      {
        type: 'inside',
        realtime: true,
        start: 0,
        end: 100,
      },
    ],
    series: [],
  } as EChartsOption
}

function getRandomColor() {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

export default Vue.extend({
  name: 'SingleComplexTrend',
  components: { cTrend },
  props: {
    value: {
      type: Object,
      required: true,
    },
    params: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      parameters: [] as Parameter[],
      chartOption: generateDefaultOption(),
      colors: [] as string[],
    }
  },
  methods: {
    async updateTrend(result: InfluxResult) {
      if (!result.Series) {
        this.chartOption = generateDefaultOption()
        return
      }

      if (result.Series.length == 0) {
        this.chartOption = generateDefaultOption()
        return
      }

      const values = result.Series[0].values

      // eslint-disable-next-line
      const opts = generateDefaultOption() as any

      opts.tooltip = {
        trigger: 'axis',
        axisPointer: {
          lineStyle: {
            color: '#57617B',
          },
        },
        formatter: (
          // eslint-disable-next-line
          params: any | any[],
          ticket: string,
          callback: (ticket: string, html: string) => void
        ) => {
          if (params.length < 1) {
            return
          }

          setTimeout(() => {
            const time = moment(params[0].axisValue).format(
              'DD MMM YYYY, HH:mm:ss'
            )

            let result = `
              <div><small>${time}</small></div>
              `
            // eslint-disable-next-line
            params.map((p: { [key: string]: any }) => {
              const parameter = this.parameters.find(
                (par) => par.name == p.seriesName
              )
              const value = p.data[1]
              if (parameter) {
                let v = ''
                if (typeof value == 'number') {
                  v = value.toFixed(parameter.precision || 3)
                }
                const name = parameter.nameHTML || parameter.name
                result += `<div>${
                  p.marker
                } ${name}: ${v} ${parameter.engineeringUnitHTML ||
                  parameter.engineeringUnit}</div>`
              } else {
                result += `<div>${p.marker} ${p.seriesName} : ${value}</div>`
              }
            })

            callback(ticket, result)
          }, 10)

          return 'Loading...'
        },
      }

      for (let i = 1; i < result.Series[0].columns.length; i++) {
        const columnName = result.Series[0].columns[i]

        const parameter = this.parameters.find((p) => p.name == columnName)

        if (typeof parameter == 'undefined') {
          continue
        }

        const serie = {
          name: columnName,
          htmlTitle: parameter.nameHTML,
          engineeringUnit: parameter.engineeringUnit,
          engineeringUnitHTML: parameter.engineeringUnitHTML,
          valueMin: 0,
          valueMax: 0,
          valueAvg: 0,
          valueMinF: '',
          valueMaxF: '',
          valueAvgF: '',
          bakuMutu: parameter.standar,
          bakuMutuEnabled: parameter.standarEnabled,
          color: parameter.color || getRandomColor(),
          type: 'line',
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          // areaStyle: {
          //   opacity: 0.15,
          // },
          itemStyle: {
            normal: {
              borderWidth: 12,
            },
          },
          data: values.map((value) => {
            return [value[0], value[i]]
          }),
        }

        let sumData = 0
        for (const r of serie.data) {
          sumData += r[1]
          if (r[1] < serie.valueMin) {
            serie.valueMin = r[1]
          }
          if (r[1] > serie.valueMax) {
            serie.valueMax = r[1]
          }
        }
        serie.valueAvg = sumData / serie.data.length

        serie.valueMinF = serie.valueMin.toFixed(parameter.precision)
        serie.valueMaxF = serie.valueMax.toFixed(parameter.precision)
        serie.valueAvgF = serie.valueAvg.toFixed(parameter.precision)

        opts.series.push(serie)
      }

      this.chartOption = opts
    },

    toggleLegend($event: PointerEvent, name: string) {
      // eslint-disable-next-line
      ;(this.$refs.echats as any).$refs.echarts.dispatchAction({
        type: 'legendToggleSelect',
        name,
      })
      if ($event.target) {
        ;($event.target as HTMLElement).classList.toggle('hidden')
      }
    },
  },

  watch: {
    value: {
      deep: true,
      handler: function(val: InfluxResult) {
        this.updateTrend(val)
      },
    },

    params: function(val: Parameter[]) {
      this.parameters = val
    },
  },

  created() {
    this.parameters = this.params as Parameter[]
    this.updateTrend(this.value)
  },
})
